export { SatisfactionsMiscDomainService } from './satisfactions-misc-domain.service';
